var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEpub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "url(#paint0_linear_1965_11885)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.8885 21.1045L7.67406 14.8886L13.8885 8.67415L15.961 10.7455L11.8168 14.8886L13.8889 16.9607L20.1044 10.7462L14.6902 5.33201C14.2482 4.88933 13.531 4.88933 13.0887 5.33201L4.33119 14.0884C3.8896 14.5311 3.8896 15.2483 4.33119 15.6906L13.0883 24.447C13.5306 24.8893 14.2482 24.8893 14.6898 24.447L23.4469 15.6903C23.8889 15.248 23.8889 14.5303 23.4469 14.0888L22.1754 12.8183L13.8885 21.1045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8885 22.1045L9.67406 15.8886L15.8885 9.67415L17.961 11.7455L13.8168 15.8886L15.8889 17.9607L22.1044 11.7462L16.6902 6.33201C16.2482 5.88933 15.531 5.88933 15.0887 6.33201L6.33119 15.0884C5.8896 15.5311 5.8896 16.2483 6.33119 16.6906L15.0883 25.447C15.5306 25.8893 16.2482 25.8893 16.6898 25.447L25.4469 16.6903C25.8889 16.248 25.8889 15.5303 25.4469 15.0888L24.1754 13.8183L15.8885 22.1045Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1965_11885",
    x1: 0,
    y1: 0,
    x2: 32.0449,
    y2: 0.0450633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7C69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpub);
export default __webpack_public_path__ + "static/media/EPUB.003b89ea00bc6afa04f1963fa51a1fbb.svg";
export { ForwardRef as ReactComponent };